import type { CmsPageFields } from '@library/cms-blocks'

const SITE_ORIGIN = 'https://www.gousto.co.uk'

export const DEFAULT_SEO = {
  title: 'Gousto | Recipe Boxes with Fresh Ingredients Delivered',
  description:
    'Gousto recipe boxes deliver fresh, pre-portioned ingredients and easy recipes to your door. Choose from a wide weekly menu.',
  ogImage: `${SITE_ORIGIN}/images/og-default.jpg`,
  robots: 'index, follow',
} as const

type RobotsDirective = NonNullable<CmsPageFields['robots_directive']>

export type CmsSeo = {
  title: string
  description: string
  ogImage: string
  robots: RobotsDirective
  canonical: string
}

function nonEmpty(value: string | undefined, fallback: string): string {
  return value?.trim() || fallback
}

export function getCmsSeo(data: CmsPageFields | null, pageUrl: string): CmsSeo {
  return {
    title: nonEmpty(data?.seo_title, DEFAULT_SEO.title),
    description: nonEmpty(data?.seo_description, DEFAULT_SEO.description),
    ogImage: nonEmpty(data?.seo_og_image?.url, DEFAULT_SEO.ogImage),
    robots: data?.robots_directive || DEFAULT_SEO.robots,
    canonical: `${SITE_ORIGIN}${pageUrl}`,
  }
}
